import Olive1 from "../../../media/olive/olive1.png";
import Olive2 from "../../../media/olive/olive2.png";
import Olive3 from "../../../media/olive/olive3.png";
import Olive4 from "../../../media/olive/olive4.png";
import Olive5 from "../../../media/olive/olive5.png";
import Olive6 from "../../../media/olive/olive6.webp";

const oliveimages = [Olive1, Olive2, Olive3, Olive4, Olive5, Olive6];

export default oliveimages;
